import { render } from "./EPUBViewer.vue?vue&type=template&id=04a8d338"
import script from "./EPUBViewer.vue?vue&type=script&lang=js"
export * from "./EPUBViewer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__